import foodCourt from '@/api/inventory/food-court'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, edit_data) {
    state.edit_data = edit_data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return foodCourt.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return foodCourt.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await foodCourt.find(id)
      context.commit('SET_EDIT_DATA', response.data)
      return Promise.resolve(response.data)
    }
  },
  update(context, data) {
    return foodCourt.update(data)
  },

  delete(context, id) {
    return foodCourt.destroy(id)
  }
}
